import { privateClient } from '@/data/api/clients/privateClient'

export type TSafetyGateResponse = {
  conversation_id: string
  safety_gate_status: string
  emergency_message?: string | null
}

export const submitRegisteredSafetyGate = async (conversationId: string, imminentDanger: boolean): Promise<TSafetyGateResponse> => {
  const { data } = await privateClient.post<TSafetyGateResponse>(`/conversations/${conversationId}/safety-gate`, {
    imminent_danger: imminentDanger,
  })
  return data
}
